import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetRewardModel } from "@factory/model/query-model-reward";
import { rewardFormDefault } from "./form.default";
import { RewardFormSchema } from "./form.rule";

export const useFormDefaultReward = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRewardModel | undefined) => {
    return !cachedValue
      ? rewardFormDefault
      : ({
          tenant: cachedValue.tenant,
          isPoints: Boolean(cachedValue.is_points),
          isStamp: Boolean(cachedValue.is_stamp),
          denominationPoints: cachedValue.denomination_points,
          points: cachedValue.points,
          denominationStamp: cachedValue.denomination_stamp,
          stamp: cachedValue.stamp,
          isActive: cachedValue.is_active,
        } as RewardFormSchema);
  };

  return {
    getDefault,
  };
};
